import { permissionManager } from "../PermissionManager/PermissionManager";

export const ADD_COMMENT = 'add_comment';
export const EDIT_PDF = 'edit_pdf';
export const ESIGN_CN = 'esign_cn';
export const ORGANIZE_PDF = 'organize_pdf';
export const DRAG_FILE_TO_OPEN = 'drag_file_to_open';
export const ESIGN_CHINA_PDF = 'esign_china_pdf';

export const SHARE_DOC  = 'share_doc';
export const ESIGN_DOC  = 'esign_doc';
export const OPEN_FILE = 'open_file';
export const HOME_TAB_START = 'home_tab_start';
export const HOME_TAB_SHARED = 'home_tab_shared';
export const HOME_TAB_TEMPLATE = 'home_tab_template';
export const ESIGN_AGREEMENTS = 'eSign_agreements';

export const SWITCH_PERIOD = 'switch_period';
export const SUBSCRIBE_PHANTOMPDF_BUSINESS_YEARLY = 'subscribe_phantompdf_business_yearly';
export const SUBSCRIBE_PHANTOMPDF_BUSINESS_MONTHLY = 'subscribe_phantompdf_business_monthly';
export const SUBSCRIBE_PHANTOMPDF_STANDARD_YEARLY = 'subscribe_phantompdf_standard_yearly';
export const SUBSCRIBE_PHANTOMPDF_STANDARD_MONTHLY = 'subscribe_phantompdf_standard_monthly';
export const SUBSCRIBE_PHANTOMPDF_ONLINE_YEARLY = 'subscribe_phantompdf_online_yearly';
export const SUBSCRIBE_PHANTOMPDF_ONLINE_MONTHLY = 'subscribe_phantompdf_online_monthly';

export const UPDATE_PASSWORD = 'update_password';
export const UPDATE_PASSWORD_OK = 'update_password_ok';
export const UPDATE_NAME = 'update_name';
export const UPDATE_NAME_OK = 'update_name_ok';
export const REDEEM_SUBSCRIPTION = 'redeem_subscription';
export const REDEEM_SUBSCRIPTION_OK = 'redeem_subscription_ok';
export const SUBSCRIBE = 'subscribe';
export const MANAGE_SUBSCRIPTION = 'manage_subscription';
export const MANAGE_PAYMENT = 'manage_payment';
export const VIEW_INVOICE = 'view_invoice';

export const DOC_PROP_IS_PASSWORD_PROTECTED = 'doc_is_password_protected';
export const DOC_PROP_PDF_STANDARD          = 'doc_pdf_standard';
export const DOC_PROP_IS_TAGGED             = 'doc_is_tagged';
export const DOC_PROP_DOCUMENT_SIZE         = 'doc_document_size';
export const  GA_FOR_SHAREPOINT = {
  open: {
    SharePoint: { eventKey: 'Share_Open', label: 'Share_Open', category: 'ADDIN', action: 'ADDIN_Share_Open'},
    OneDrive: { eventKey: 'One_Open', label: 'One_Open', category: 'ADDIN', action: 'ADDIN_One_Open'},
  },
  convert: {
    SharePoint: { eventKey: 'Share_Convert', label: 'Share_Convert', category: 'ADDIN', action: 'ADDIN_Share_Convert'},
    OneDrive: { eventKey: 'One_Convert', label: 'One_Convert', category: 'ADDIN', action: 'ADDIN_One_Convert'},
  },
  combine: {
    SharePoint: { eventKey: 'Share_Combine', label: 'Share_Combine', category: 'ADDIN', action: 'ADDIN_Share_Combine'},
    OneDrive: { eventKey: 'One_Combine', label: 'One_Combine', category: 'ADDIN', action: 'ADDIN_One_Combine'},
  },
  export: {
    SharePoint: { eventKey: 'Share_Export', label: 'Share_Export', category: 'ADDIN', action: 'ADDIN_Share_Export'},
    OneDrive: { eventKey: 'One_Export', label: 'One_Export', category: 'ADDIN', action: 'ADDIN_One_Export'},
  },
  organize: {
    SharePoint: { eventKey: 'Share_Organize', label: 'Share_Organize', category: 'ADDIN', action: 'ADDIN_Share_Organize'},
    OneDrive: { eventKey: 'One_Organize', label: 'One_Organize', category: 'ADDIN', action: 'ADDIN_One_Organize'},
  },
}

permissionManager.registerPremiumFeatures([
  SHARE_DOC,
]);
permissionManager.registerCNJPPremiumFeatures([
  SHARE_DOC,
])